<script>
	import * as animationData from '@/assets/animations/loading.json';
	import Lottie from 'vue-lottie';

	export default {
		components: {
			Lottie
		},
		data() {
			return {
				defaultOptions: {
					loop: true,
					autoplay: true,
					animationData: animationData.default
				},
				animationSpeed: 1,
				showLoadingMessage: false,
				loadingMessage: "Please Wait..."
			};
		},
		created() {
			setTimeout(() => {
				this.showLoadingMessage = true;
				setTimeout(() => {
					this.loadingMessage = "Things are taking a little longer than usual...";
				}, 10000)
			}, 3000)
		},
		methods: {
			handleAnimation(anim) {
				this.anim = anim;
			}
		}
	};
</script>

<template>
	<v-container class="loading-container" fluid>
			<v-layout align-center justify-center>
				<v-flex xs12 sm8 md6>
					<v-flex class="text-center">
						<Lottie :options="defaultOptions" :height="300" :width="300" />

						<h2 v-if="showLoadingMessage">{{ loadingMessage }}</h2>
				
					</v-flex>
				</v-flex>
			</v-layout>
		</v-container>
</template>

<style scoped>
    .loading-container {
        background-color: #fafafa;
        position: fixed;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
    }
</style>